import React from 'react';
import { RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { RichTextRendering } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C26RichTextProps = RenderingProps<C26RichTextFields, C26RichTextParams>;

export type C26RichTextParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C26RichTextFields = {
  RichText?: RichTextField;
};

export const Default = (props?: C26RichTextProps): JSX.Element => {
  const { renderRichText } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <RichTextRendering
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    >
      {renderRichText(props?.fields?.RichText)}
    </RichTextRendering>
  );
};
